import PropTypes from 'prop-types';
import './styles/utilityNavStyles.css';

const UtlityNavigationMenu = ({ children }) => (
  <div className="utility-navigation flex-none flex flex-nowrap flex-row justify-end items-center">
    {children}
  </div>
);

UtlityNavigationMenu.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UtlityNavigationMenu;
